import { signal, computed, effect } from "@preact/signals";
import type { AppState, Schedule, Term } from "./types";
import { emptyState } from "./share";

const KEY = "ss.state.v1";
const SETTINGS = "ss.settings.v1";

function load(): AppState {
  try { const s = JSON.parse(localStorage.getItem(KEY) || "null"); if (s?.v === 1 && s.schedules?.length) return s; } catch { /* ignore */ }
  return emptyState();
}

export const state = signal<AppState>(load());
effect(() => localStorage.setItem(KEY, JSON.stringify(state.value)));

export const active = computed<Schedule>(() => state.value.schedules[state.value.active] ?? state.value.schedules[0]);

export function update(fn: (s: Schedule) => void) {
  const st = structuredClone(state.value);
  fn(st.schedules[st.active]);
  state.value = st;
}

export function setActive(i: number) { state.value = { ...state.value, active: i }; }
export function addSchedule(s: Schedule) { const st = structuredClone(state.value); st.schedules.push(s); st.active = st.schedules.length - 1; state.value = st; }
export function removeSchedule(i: number) {
  const st = structuredClone(state.value);
  st.schedules.splice(i, 1);
  if (!st.schedules.length) st.schedules = emptyState().schedules;
  st.active = Math.min(st.active, st.schedules.length - 1);
  state.value = st;
}

export const isPicked = (id: string) => active.value.picks.some((p) => p.id === id);
export function togglePick(id: string, term?: Term | null) {
  update((s) => {
    const i = s.picks.findIndex((p) => p.id === id);
    if (i >= 0) s.picks.splice(i, 1);
    else { s.picks.push({ id, sel: {} }); if (term && !s.picks.slice(0, -1).length) s.term = term; }
  });
}

export interface Settings { lang: "bs" | "en"; myName: string; myIntro: string; role: "auditor" | "student" | "guest"; clock: 24 | 12 }
export const settings = signal<Settings>({ lang: "bs", myName: "", myIntro: "", role: "auditor", clock: 24, ...(JSON.parse(localStorage.getItem(SETTINGS) || "{}")) });
effect(() => localStorage.setItem(SETTINGS, JSON.stringify(settings.value)));
